import React, { useState, useEffect } from "react";
import BookButton from "../components/BookButton";
import TeamMember from "../components/TeamMember";
import teamData from '../assets/teamData.json';
import { HiArrowCircleDown } from "react-icons/hi";


const About = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
  const [activeDropdown, setActiveDropdown] = useState(null);


  const handleDropdownClick = (dropdownName) => {
    setActiveDropdown(dropdownName === activeDropdown ? null : dropdownName);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1000);
    };

    window.addEventListener("resize", handleResize);

    // Check screen width on mount
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);


  return (
    <div className="about-container">

      <div className={isMobile ? "block" : "flex"}>
        <div className="about-title mtitle">
          <h1>ABOUT</h1>
        </div>
        <div className="about-text">
          <p>At Higher Low Productions, we are not just a production company; we are a catalyst for creative empowerment. Our passion lies in fueling the ambitions of creators, allowing them to reach new heights while retaining full control over their artistic endeavors. With our tailored suite of services, we offer comprehensive creative and video content, from script development to post-production. We forge strong partnerships with clients, mitigating risks and empowering creators to make informed decisions about their investments. Our collaborative approach, supported by a diverse and talented team of filmmakers, brings expertise and experience to breathe life into your vision. We prioritize meaningful relationships and provide personalized support, embracing a sustainable path that focuses on empowering creators and helping them achieve their creative goals.</p>
        </div>
      </div>
      <div className="section-separator"></div>
      <div className={isMobile ? "block" : "flex"}>
        <div className="services-title mtitle">
          <h1>SERVICES</h1>
        </div>
        <div className="services-text">
          <ul>
            <li
              onClick={() => handleDropdownClick('preProduction')}
            >
              PROJECT DEVELOPMENT <span id='arrow' className={activeDropdown === 'preProduction' ? 'active-title' : ''}><HiArrowCircleDown style={{ fontSize: '26px' }}/></span>
              {activeDropdown === 'preProduction' && (
                <div className="dropdown-content">
                  <ul>
                    <li>consultation</li>
                    <li>script development</li>
                    <li>pitch deck creation</li>
                    <li>investor relations</li>
                    <li>grant application support</li>
                  </ul>
                </div>
              )}
            </li>
            <li
              onClick={() => handleDropdownClick('production')}
            >
              PRODUCTION MANAGMENT <span id='arrow' className={activeDropdown === 'production' ? 'active-title' : ''}><HiArrowCircleDown style={{ fontSize: '26px' }}/></span>
              {activeDropdown === 'production' && (
                <div className="dropdown-content">
                  <ul>
                    <li>budgeting</li>
                    <li>scheduling</li>
                    <li>casting</li>
                    <li>insurance & permitting</li>
                    <li>post-production coordination</li>
                  </ul>
                </div>
              )}
            </li>
            <li
              onClick={() => handleDropdownClick('postProduction')}
            >
              CONTENT DELIVERY <span id='arrow' className={activeDropdown === 'postProduction' ? 'active-title' : ''}><HiArrowCircleDown style={{ fontSize: '26px' }}/></span>
              {activeDropdown === 'postProduction' && (
                <div className="dropdown-content">
                  <ul>
                    <li>branded content</li>
                    <li>live events</li>
                    <li>animation</li>
                    <li>marketing campaigns</li>
                  </ul>
                </div>
              )}
            </li>
          </ul>
        </div>
      </div>

      <div className="section-separator"></div>

      <div className={isMobile ? "block" : "flex"}>
        <div className="team-title mtitle">
          <h1>FOUNDER</h1>
        </div>
        <div className="team-text-f">

          <TeamMember
            key={1000}
            imageSrc={teamData[0].imageSrc}
            firstname={teamData[0].firstname}
            lastname={teamData[0].lastname}
            title={teamData[0].title}
            biography={teamData[0].biography}
          />

        </div>
      </div>

      <div className="section-separator"></div>

      <div className={isMobile ? "block" : "flex"}>
        <div className="team-title mtitle">
          <h1>OUR TEAM</h1>
        </div>
        <div>
          <div className={isMobile ? "block mobile-center" : "flex team-text"}>
            {teamData.slice(1, 4).map((member, index) => (
              <TeamMember
                key={index}
                imageSrc={member.imageSrc}
                firstname={member.firstname}
                lastname={member.lastname}
                title={member.title}
                biography={member.biography}
              />
            ))}
          </div>
          <div className={isMobile ? "block mobile-center" : "flex team-text"}>
            {teamData.slice(4, 7).map((member, index) => (
              <TeamMember
                key={index}
                imageSrc={member.imageSrc}
                firstname={member.firstname}
                lastname={member.lastname}
                title={member.title}
                biography={member.biography}
              />
            ))}
          </div>
          <div className={isMobile ? "block mobile-center" : "flex team-text"}>
            {teamData.slice(7).map((member, index) => (
              <TeamMember
                key={index}
                imageSrc={member.imageSrc}
                firstname={member.firstname}
                lastname={member.lastname}
                title={member.title}
                biography={member.biography}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="section-separator"></div>

      <div className={isMobile ? "block" : "flex"}>
        <div className="more-title mtitle">
          <h1>WANNA CONNECT?</h1>
        </div>
        <div className="more-text">
          <h1>SCHEDULE A FREE CONSULTATION <span className="arrow-size"><HiArrowCircleDown style={{ fontSize: '26px' }}/></span></h1>
          <BookButton />
        </div>
      </div>

      <div className="section-separator"></div>

    </div>
  );
}

export default About;